package cc.bluepeak.clubmanager.site.pages

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.components.layouts.PageLayoutData
import cc.bluepeak.clubmanager.site.components.sections.ContactSection
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout

@InitRoute
fun initContact(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Res.string.contact, Res.string.contact_title))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun Contact() {
    ContactSection()
}